import { call, delay, put, select, takeEvery, takeLatest } from "redux-saga/effects"
import { defineErroLogin, defineLogando, defineToken, triggerLogar, triggerSair, updateDadosLogin } from "./AuthenticationSlice";

import { server_url } from '../core/config_geral'
import axios from 'axios';

function* doSair() {
    yield call(() => localStorage.removeItem("token"))
    yield put(defineToken(null))
}


function* doLogar() {
    // yield call(() => console.log("Logando"));
    yield put(defineErroLogin(""))
    yield put(defineLogando(true))

    yield delay(500)

    var auth = yield select((state) => state.auth);

    var isEmpty = (value) => typeof (value) === "undefined" ? true
        : value == null ? true
            : value.trim().length == 0 ? true : false

    if (isEmpty(auth.login.email)) {
        yield put(defineErroLogin("Preencha o campo email..."))
    } else if (isEmpty(auth.login.password)) {
        yield put(defineErroLogin("Forneça a senha..."))
    } else {

        var r = yield call(() => axios.post(server_url + "/api/v1/auth/authenticate", {
            username: auth.login.email,
            password: auth.login.password
        }).then(response => {
            const uId = response.data['token'];
            return { token: uId }
        })
            .catch(error => error))

        if (r.token) {
            localStorage.setItem("token", r.token)
            yield put(defineToken(r.token))
            // var t = yield select((state) => state.auth.token)
            // yield call(() => console.log("token (2)", t))
        } else {
            if (r.code == "ERR_NETWORK") {
                yield put(updateDadosLogin({
                    campo: "erro",
                    valor: "Servidor ou internet inacessível: " + server_url
                }))
            } else {
                yield put(updateDadosLogin({
                    campo: "erro",
                    valor: "Usuário não encontrado"
                }))
            }
        }
    }

    yield put(defineLogando(false))

}


export function* listenSair() {
    yield takeLatest(triggerSair, doSair)
}
export function* listenLogar() {
    yield takeEvery(triggerLogar, doLogar);
}